import { axios } from 'lib/axios';
import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';
import { useAuth } from 'lib/auth';
import { toPlaceInputs } from 'utils/jobAdLocations';

const createRequest = async (values) => {
  const jsonData = {
    fa_id: values.instrumentType === 'fa' ? Number(values.instrumentId) : values.agreement ? Number(values.agreement) : null,
    dps_id: values.instrumentType === 'dps' ? Number(values.instrumentId) : values.dps ? Number(values.dps) : null,
    direct_id: values.instrumentType === 'direct' ? Number(values.instrumentId) : null,
    buyer_id: Number(values.buyer),
    supplier_id: values.supplierID ? Number(values.supplierID) : null,
    hide_buyer: values.hideBuyer ?? false,
    source_ad_id: values.sourceAdID ? Number(values.sourceAdID) : null,
    headline: values.headline,
    role: values.role,
    experience_level: values.experienceLevel,
    description: values.description,
    max_rate: values.maxRate,
    reference_number: values.referenceNumber,
    start_date: values.startDate,
    end_date: values.endDate,
    application_method: values.applicationType,
    application_email: values.applicationEmail,
    application_url: values.applicationURL,
    last_day_to_respond: values.lastDayToRespond,
    questions_end_date: values.questionsEndDate,
    competence_areas: values?.competenceAreas,
    locations: values?.usesNuts ? values?.locations : [],
    places: toPlaceInputs(values?.places),
    additional_periods: values?.additionalPeriods,
    assigned_user_id: values?.assigned_user_id,
    type: values?.type,
    hours_per_week: values?.hoursPerWeek,
    last_updated_user_id: values?.last_updated_user_id,
  };

  return axios.post('/api/job_ads', JSON.stringify(jsonData));
};

export const useCreate = ({ successMessage = 'Job Advertisement created successfully' } = {}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { user } = useAuth();

  return useMutation({
    mutationFn: (data) => createRequest({last_updated_user_id: user.user_id, ...data}),
    onSuccess: () => {
      enqueueSnackbar(successMessage, {
        variant: 'success',
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      });
    },
    onError: (error) => {
      enqueueSnackbar(error?.response?.data?.error || error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
